module.exports = __webpack_public_path__ + "static/media/jaqueline.800ecc45.png";